interface StepOption<T> {
  value: T
  label: string
  /** Bredere knap, fx "Solo" ved siden af niveau-trinene. */
  wide?: boolean
}

interface PickStepsProps<T> {
  options: StepOption<T>[]
  /** Om en given knap skal vises som valgt. Standard: value === opt.value. */
  isActive?: (opt: StepOption<T>) => boolean
  value?: T
  onChange: (value: T) => void
  className?: string
}

function PickSteps<T>({ options, isActive, value, onChange, className = '' }: PickStepsProps<T>) {
  return (
    <div className={`flex gap-1 ${className}`}>
      {options.map((opt, i) => {
        const active = isActive ? isActive(opt) : opt.value === value
        return (
          <button
            key={i}
            type="button"
            onClick={() => onChange(opt.value)}
            className={`min-h-[calc(44px*var(--scale))] rounded-[10px] bg-ink/25 font-mono font-semibold ${
              opt.wide ? 'flex-[1.4]' : 'flex-1'
            } ${active ? 'bg-cream text-ink' : 'text-text-2'}`}
          >
            {opt.label}
          </button>
        )
      })}
    </div>
  )
}

export default PickSteps
